export { createEditorPermissionsEntryPoint } from './editorPermissionsEntryPoint';
export type { EditorPermissions } from './editorPermissionsEntryPoint';
